import { render, staticRenderFns } from "./PaymentsDetailView.vue?vue&type=template&id=ab6ca6a8&"
import script from "./PaymentsDetailView.vue?vue&type=script&lang=ts&"
export * from "./PaymentsDetailView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports